import { WaterRegistrationModel } from "@/core/models/water-registration/water-registration.model";
import { ContractModel } from "@/core/models/contracts/contract.model";
import { TollAreaModel } from "@/core/models/toll-area/toll-area.model";
import { TollAreaRepo } from "@/core/repos/tables/toll-area.repo";
import container from "@/lib/di/container";

import { factoryRuntimeSettings } from "@/core/stores/factory-runtime-settings.store";

const tollAreaRepo = container.get(TollAreaRepo);

/**
 * Map WaterRegistrationModel to Partial ContractModel
 * Maps fields from UseWaterRegister to CreateWaterUserModel according to API documentation
 */
export function mapWaterRegistrationToContract(
    register: WaterRegistrationModel
): Partial<ContractModel> {
    // Determine IdentityCode: có TaxCode = tổ chức (2), không có = cá nhân (1)
    const identityCode = register.taxCode ? 2 : 1;
    
    // Determine Organization: nếu có TaxCode thì là công ty
    const organization = register.taxCode ? register.name : undefined;
    
    return {
        // Required - cần nhập thủ công
        // code: '', // Generate hoặc nhập
        // tollAreaId: '', // Tìm từ location
        identityCode, // Auto-detect từ TaxCode
        
        // Mapped từ UseWaterRegister
        name: register.name || register.representative,
        phone: register.mobilePhone || register.landlinePhone || "",
        email: register.email || "",
        taxCode: register.taxCode || "",
        bankNo: register.bankNo || "",
        bank: register.bankName || "",
        address: register.address || "",
        identityNo: register.identification || "",
        identityDate: register.identificationDate || "",
        waterFactoryId: register.waterFactoryId,
        unitTypeId: register.unitTypeId,
        organization: organization || "",
        
        // Defaults - đọc từ config, fallback về giá trị mặc định
        waterMeterName: factoryRuntimeSettings.string("defaultWaterMeterName", process.env.REACT_APP_DEFAULT_WATER_METER_NAME || "Aichi Tokei"),
        waterMeterType: factoryRuntimeSettings.string("defaultWaterMeterType", process.env.REACT_APP_DEFAULT_WATER_METER_TYPE || "C15"),
        status: "Processing", // Đang đăng ký - mặc định
        depositStatus: "No",
        
        // Optional fields - có thể để trống
        userName: register.mobilePhone || register.landlinePhone || "",
        notificationMethod: "",
        paymentMethod: "",
        gps: "",
        normalizeName: "",
        externalId: "",
        note: "",
        collector: "",
        requiredDepositAmount: 0,
        depositAmount: 0,
        supportCashRate: 0,
        numberOfPeople: 0,
        lastWaterMeterNumber: 0,
        identityPlace: "",
        identityProPlace: "",
        createdBy: "",
        updatedBy: "",
    };
}

/**
 * Find TollArea by location (provinceId, districtId, wardId)
 * Returns the first matching TollArea or null if not found
 */
export async function findTollAreaByLocation(
    provinceId: string,
    districtId: string,
    wardId: string
): Promise<TollAreaModel | null> {
    try {
        const result = await tollAreaRepo.getData(1, {
            provinceId,
            districtId,
            wardId,
        }, 1);
        
        if (result && result.data.length > 0) {
            return result.data[0]; // Lấy TollArea đầu tiên
        }
        return null;
    } catch (err) {
        console.log("Error finding TollArea by location:", err);
        return null;
    }
}

